import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["name", "categories", "subjects", "result", "waiting", "message", "form", "qr", "qrImage"]
  static values = {
    product: String,
    qrUrl: String,
    location: String,
    appointment: String,
    category: String,
    shouldRefresh: Boolean,
    userId: String,
    categoryId: String,
    success: Boolean,
    status: String
  }

  connect() {
    this.#checkIfSubjectsAreLoaded();

    if (this.hasQrTarget) {
      this.#generateQrCode(this.shouldRefreshValue);
    }

    if (['checking_out', 'trigger_reload'].includes(this.statusValue)) {
      this.triggerKioskReload();
    }

    if (this.hasSuccessValue && this.successValue == false) {
      this.#resetNameField();
    }

    // Card swipe initialization
    $.cardswipe({
      firstLineOnly: true,
      parsers: ["generic"],
      success: this.successLogger,
      error: this.swipeError,
      debug: false
    });

    this.#setupSwipe(this);
  }

  submitCheckIn(event) {
    let formTarget = event.target.closest('form');
    let categoryId = event.target.dataset.id;
    let course = event.target.dataset.course;
    let section = event.target.dataset.section;
    var input = document.createElement('input');

    input.type = 'text';
    input.name = 'category_id';
    input.value = categoryId;
    input.id = 'categoryId';
    input.style.display = 'none';
    formTarget.appendChild(input);

    if (course) {
      var input2 = document.createElement('input');
      input2.type = 'text';
      input2.name = 'course_subject';
      input2.value = course;
      input2.id = 'courseSubject';
      input2.style.display = 'none';
      formTarget.appendChild(input2);
    }

    if (section) {
      var input3 = document.createElement('input');
      input3.type = 'text';
      input3.name = 'course_section';
      input3.value = section;
      input3.id = 'courseSection';
      input3.style.display = 'none';
      formTarget.appendChild(input3);
    }

    $('#kioskResult .kiosk-subjects .btn').remove();

    formTarget.addEventListener('turbo:submit-end', (event) => {
      const { success } = event.detail;

      if (success && this.statusValue != 'checking_in') {
        setTimeout(() => window.location.reload(), 2000);
      } else {
        this.#updateKioskResult('alert-danger', 'Check-in failed');
      }
    });

    // form submission via Turbo
    formTarget.requestSubmit();
  }

  submitting(event) {
    const waitingElement = event.target.querySelector('.kiosk-waiting');
    waitingElement.style.display = 'block';
  }

  // deprecated, but still used in Pulse check-ins webview
  onPostSuccess(event) {
    let [data, status, xhr] = event.detail;
    var style;
    let existingCategory = document.getElementById("categoryId");
    let existingCourse = document.getElementById("courseSubject");
    let existingSection = document.getElementById("courseSection");
    if (existingCategory) {
      existingCategory.remove();
    }
    if (existingCourse) {
      existingCourse.remove();
    }
    if (existingSection) {
      existingSection.remove();
    }
    style = (data.success ? "alert-success" : "alert-danger");
    if (data.multi == true) {
      this.#presentCategories();
    } else if (data.choose_subject == true) {
      this.#fetchUserCourseSubjects(data.user_id, data.category_id);
    } else {
      this.#updateKioskResult(style, data.message);
    }
  }

  #checkIfSubjectsAreLoaded() {
    if (this.hasSubjectsTarget && this.userIdValue && this.categoryIdValue) {
      this.#fetchUserCourseSubjects(this.userIdValue, this.categoryIdValue);
    }
  }

  #resetNameField() {
    if (!this.hasNameTarget) return;

    this.nameTarget.value = "";
    this.nameTarget.focus();
  }

  #setupSwipe(_this) {
    $(document).on("scanstart.cardswipe", function() {
      _this.waitingTarget.style.display = 'block';
    });

    $(document).on("success.cardswipe", function(event, data) {
      _this.swipeComplete(data);
    });
  }

  #generateQrCode(intiate_refresh) {
    fetch(`${this.productValue === 'pulse' ? '/pulse' : ''}/locations/${this.locationValue}/qr_code?appointment_id=${this.appointmentValue}&category_id=${this.categoryValue}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then((response) => response.json())
      .then((data) => {
        this.qrImageTarget.src = data.code;
        if (intiate_refresh == true) {
          this.#startRefreshing();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  #startRefreshing() {
    setInterval(() => {
      this.#generateQrCode(false);
    }, '60000')
  }


  triggerKioskReload() {
    setTimeout(() => window.location.reload(), 2000);
  }

  #updateKioskResult(style, msg) {
    const name = this.nameTargetExists ? this.nameTarget : document.getElementById('user_unique_id');
    const message = this.messageTargetExists ? this.messageTarget : document.querySelector('.kiosk-result');
    const waiting = this.waitingTargetExists ? this.waitingTarget : document.querySelector('.kiosk-waiting');

    this.#resetNameField();
    message.classList.remove("alert-info", "alert-success", "alert-danger");
    message.classList.add(style);
    message.innerHTML = msg;
    waiting.style.display = 'none';

    if (msg !== undefined) {
      message.style.display = 'block';

      setTimeout(() => message.style.display = 'none', 4000)
    }
  }

  #presentCategories() {
    this.waitingTarget.style.display = 'none';
    this.categoriesTarget.style.display = 'block';
  }

  #fetchUserCourseSubjects(user_id, category_id) {
    fetch(`/students/${user_id}/enrolled_course_subjects`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then((response) => response.json())
      .then((data) => {
        this.waitingTarget.style.display = 'none';

        if (this.hasCategoriesTarget) {
          this.categoriesTarget.style.display = 'none';
        }
        if (data.length > 0) {
          $.each(data, function(i, val) {
            $('.subject-buttons').append(
              `<button type="button" class="btn btn-light m-1" data-id="${category_id}" data-course="${val.name}" data-section="${val.section}" data-action="click->kiosk#submitCheckIn">${val.name}</button>`
            );
          });
        };

        $('.subject-buttons').append(
          `<button type="button" class="btn btn-light m-1" data-id="${category_id}" data-course="Other" data-action="click->kiosk#submitCheckIn">Other</button>`
        );

        this.subjectsTarget.style.display = 'block';
      })
      .catch((error) => {
        this.#updateKioskResult('alert-danger', error);
      });
  }

  swipeComplete(swipe_data) {
    var locationId = this.nameTarget.dataset.locationId;
    var categoryCount = parseInt(this.nameTarget.dataset.categoryCount);
    var eventId = this.nameTarget.dataset.eventId;
    var checkInCategoryId;
    var checkInCategory;
    var style;
    if (categoryCount == 1) {
      checkInCategory = $('#kiosk .kiosk-categories .btn').first();
      checkInCategoryId = $(checkInCategory).data('id');
    };
    fetch(`${this.productValue === 'pulse' ? '/pulse' : ''}/locations/${locationId}/swipe`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        track_1: swipe_data.line1,
        track_2: swipe_data.line2,
        track_3: swipe_data.line3,
        event_id: eventId,
        category_id: checkInCategoryId
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        this.nameTarget.value = data.unique_id;
        style = (data.success ? "alert-success" : "alert-danger");
        if (data.multi == true) {
          this.#presentCategories();
        } else if (data.choose_subject == true) {
          this.#fetchUserCourseSubjects(data.user_id, data.category_id);
        } else {
          this.#updateKioskResult(style, data.message);
        };
      })
      .catch((error) => {
        console.error('Error:', error);
        this.#resetNameField();
      });
  }

  successLogger() {
  }

}
